import {Routes} from '@angular/router';

import {InvoicesComponent} from './components/invoices/invoices.component';

export const INVOICES_ROUTES: Routes = [

  {path: 'invoices', component: InvoicesComponent},

];
